import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { ICompanyLanguageConfig } from '../common/models/Company'

// Applies a company's language preference to i18next: switches to the configured
// language and, when a custom translation file is set, merges its term overrides
// into the bundle. Shared by the public Employer Branding pages (manifesto/home,
// careers, library) so external visitors see the company's language and custom
// terminology, identically to how App.tsx applies them in-platform.
const useApplyCompanyLanguage = (
  languageConfig?: ICompanyLanguageConfig
): void => {
  const { i18n } = useTranslation()

  useEffect(() => {
    if (!languageConfig?.language) return

    const apply = async () => {
      await i18n.changeLanguage(languageConfig.language)
      if (!languageConfig.file) {
        await i18n.reloadResources(languageConfig.language, 'translation')
        return
      }
      const data = await fetch(languageConfig.file, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then((response) => response.json())
      if (!data) return
      i18n.addResourceBundle(
        languageConfig.language,
        'translation',
        data,
        true,
        true
      )
    }

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    apply()
  }, [languageConfig?.language, languageConfig?.file])
}

export default useApplyCompanyLanguage
